export const sortExtensions = ( extensions: string[] ) => extensions.sort(
	( value, otherValue ) => value.localeCompare( otherValue )
);
